/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_B_Reply_HeaderInputs */



/**
* | output |
* | --- |
* | "Group B Reply" |
*
* @param {Compare_Event_Groups_Csv_Group_B_Reply_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_b_reply_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_B_Reply_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_B_Reply_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réponse du groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort der Gruppe B")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risposta del Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ответ группы B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Respuesta del Grupo B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("B组回复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループBの返信")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह बी उत्तर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resposta do Grupo B")
	return /** @type {LocalizedString} */ ("Group B Reply")
});